import { render, staticRenderFns } from "./navbarTab.vue?vue&type=template&id=b92171a6&scoped=true&"
import script from "./navbarTab.vue?vue&type=script&lang=js&"
export * from "./navbarTab.vue?vue&type=script&lang=js&"
import style0 from "./navbarTab.vue?vue&type=style&index=0&id=b92171a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b92171a6",
  null
  
)

export default component.exports